import React from 'react'
import Navbar from './Navbar'
// import { useSelector} from "react-redux";
// import { useNavigate } from "react-router-dom";
import MainContainer from './MainContainer';
import MovieContainer from './MovieContainer';
import useNowPlayingMovies from '../hooks/useNowPlayingMovies';
import usePopularMovies from '../hooks/usePopularMovies';
import useTopRatedMovies from '../hooks/useTopRatedMovies';
import useUpcomingMovies from '../hooks/useUpcomingMovies';
import Footer from './Footer'



const Browse = () => {
    // my custom hooks
    useNowPlayingMovies();
    usePopularMovies();
    useTopRatedMovies();
    useUpcomingMovies();

    return (
        <div >
            <Navbar />
            <div>
                <>
                    <MainContainer />
                    <MovieContainer />
                </>
            </div>
            <Footer/>      
        </div>
    )
}
export default Browse